export default function getLabelId(id) {
  return "".concat(id, "-label");
}